import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend';
import './Component_AdvisorSL_InboxItems.scss';
import { Component_SL_Button, Component_SL_Header, Component_SL_Icon } from '@app/styles/skeleton-loaders';
const Component_AdvisorSL_InboxItem = () => {
    return _jsxs(LL_H_C, { className: 'c-asl-inbox-item', children: [_jsx(Component_SL_Icon, {}), _jsx(Component_SL_Header, { withSubtitle: true, subtitleWidth: 50, titleWidth: 'random' }), _jsx(Component_SL_Button, {})] });
};
export const Component_AdvisorSL_InboxItems = () => {
    return _jsxs(LL_V_L, { className: 'c-asl-inbox-items', children: [_jsx(Component_AdvisorSL_InboxItem, {}), _jsx(Component_AdvisorSL_InboxItem, {}), _jsx(Component_AdvisorSL_InboxItem, {}), _jsx(Component_AdvisorSL_InboxItem, {})] });
};
//# sourceMappingURL=Component_AdvisorSL_InboxItems.js.map